import { Box, Button, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import PublicLayout from "../../layouts/publicLayout";

const ComingSoon = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // go back to previous page
  };

  return (
    <PublicLayout>
        
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      textAlign="center"
      px={2}
    >
      <Typography variant="title" gutterBottom>
        🚧 Coming Soon
      </Typography>

      <Typography variant="subtitile" color="text.secondary" mb={4}>
        We're working on it. Stay tuned!
      </Typography>

      <Button
        variant="contained"
        startIcon={<ArrowBackIcon />}
        onClick={handleBack}
      >
        Go Back
      </Button>
    </Box>
    </PublicLayout>
  );
};

export default ComingSoon;
